import React, { useState } from "react";
import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import {
  // EditOutlined,
  RedoOutlined,
  CloseCircleOutlined,
  MailOutlined,
  EyeOutlined,
} from "@ant-design/icons";
// import { checkPrivileges } from '../../../../config/Global';
import UpdateRequest from "./UpdateRequest";
// import moment from 'moment';
import moment from "moment-timezone";
import CancelRequest from "../components/CancelRequest";
import ReturnRequest from "./ReturnRequest";
import { camelCaseString } from "../../../../config/Global";
import UpdateEmailModal from "./UpdateEmailModal";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { getPublishReport, getReport } from "../../../../store/SendMessageSlice";
import ViewReport from "./ViewReport";

interface DataType {
  key: string;
  index: string;
  id: string | any;
  request_retry_date: string;
  user_id: string;
  request_id: string;
  to_provider: string;
  number: string;
  network_type: String;
  number_type: String;
  from_number: string;
  to_number: string;
  email: string;
  created_date: string;
  process_status: String;
}

export const convertDateToIsrael = async (dateTime) => {
  const utcMoment = moment.utc(dateTime, "YYYY-MM-DDTHH:mm:ss");
  const israelMoment = utcMoment.tz("Asia/Jerusalem");
  const israelTime = israelMoment.tz("Asia/Jerusalem"); //.format('YYYY-MM-DDTHH:mm:ss')
  return israelTime;
};

const PublishListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
  } = props;
  const dispatch: AppDispatch = useDispatch();

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();
  const [vewReport, setViewReport] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [openCancelModal, setOpenCancelModal] = useState<boolean>(false);
  const [openCancelData, setOpenCancelData] = useState<any>();

  const [openReturnModal, setOpenReturnModal] = useState<boolean>(false);
  const [openReturnData, setOpenReturnData] = useState<any>();

  const [openUpdateEmailModal, setOpenUpdateEmailModal] = useState<boolean>(false);
  const [updateEmailData, setUpdateEmailData] = useState<any>();

  const openViewDrawer = (data: any) => {
    const payload = {
      request_id: data.request_id,
    };
    dispatch(getPublishReport(payload))
      .then((res: any) => {
        setReportData(res?.data);
        setViewReport(true);
      })
      .catch((e: any) => {
        console.warn(e);
        setViewReport(false);
      });
  };
  const closeViewDrawer = () => {
    setViewReport(false);
    setReportData(null);
  };
  // const userDetails = localStorage.getItem('userDetails');
  // const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const data: DataType[] = listData?.map((item, index) => ({
    key: index?.toString(),
    id: item?.id ?? index + 1,
    index: item?.index,
    user_id: item?.user_id,
    request_id: item?.request_id,
    to_provider: item?.to_provider,
    network_type: item?.network_type,
    number_type: item?.number_type,
    number: item?.number,
    from_number: item?.from_number,
    to_number: item?.to_number,
    created_date: item?.created_date,
    email: item?.email,
  }));

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "index",
      key: "index",
      width: 80,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },
    {
      title: "Request ID",
      dataIndex: "request_id",
      key: "request_id",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.request_id || "").localeCompare(b.request_id || ""),
      render: (_, record) => {
        return record?.request_id ? record?.request_id : CONSTANT.NO_DATA_FOUND;
      },
      fixed: "left",
    },
    {
      title: "Provider",
      children: [
        // {
        //   title: "From",
        //   dataIndex: "from_provider",
        //   key: "from_provider",
        //   width: 180,

        //   sortDirections: ["descend", "ascend"],
        //   sorter: (a, b) => (a.from_provider || "").localeCompare(b.from_provider || ""),
        //   render: (_, record) => {
        //     return record?.from_provider ? record?.from_provider : CONSTANT.NO_DATA_FOUND;
        //   },
        // },
        {
          title: "To",
          dataIndex: "to_provider",
          key: "to_provider",
          width: 180,

          sortDirections: ["descend", "ascend"],
          sorter: (a, b) => (a.to_provider || "").localeCompare(b.to_provider || ""),
          render: (_, record) => {
            return record?.to_provider ? record?.to_provider : CONSTANT.NO_DATA_FOUND;
          },
        },
      ],
    },

    {
      title: "Number",
      dataIndex: "number",
      key: "number",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.number || "").localeCompare(b.number || ""),
      render: (_, record) => {
        return record?.number ? record?.number : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
      render: (_, record) => {
        return record?.email ? record?.email : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 180,

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a?.created_date || "").localeCompare(b?.created_date || ""),
      render: (_, record) => {
        return record?.created_date ? record?.created_date : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 250,
      fixed: "right",
      // hidden: !checkPrivileges(userRoles, 'admin'),
      render: (_, record, index) => {
        const isDisabled =
          record?.process_status === "Complete" ||
          record?.process_status === "Success" ||
          record?.process_status === "Failed" ||
          record?.process_status === "Canceled";

        // const isReturnDisabled = record?.from_provider && record?.to_provider;

        return (
          <Space size="middle" wrap>
            <Tooltip title={"View Report"}>
              <Button
                type="default"
                icon={<EyeOutlined />}
                className="EditBtn iconBtn"
                onClick={() => openViewDrawer(record)}
                disabled={!record?.request_id}
              />
            </Tooltip>

            {/* {record?.return_response ? (
              <Tooltip title={"Return Request Status"}>
                <Button
                  onClick={() => {
                    handleReturnRequest(record);
                  }}
                  icon={<RedoOutlined />}
                  type="default"
                  className="EditBtn iconBtn"
                />
              </Tooltip>
            ) : (
              <Tooltip
                title={
                  isDisabled
                    ? "Can't make return request. This process is already closed."
                    : "Return Request"
                }
              >
                <Button
                  onClick={() => {
                    handleReturnRequest(record);
                  }}
                  icon={<RedoOutlined />}
                  type="default"
                  className="cancelBtn iconBtn"
                  disabled={!isReturnDisabled ? true : false}
                />
              </Tooltip> */}
            {/* )} */}
          </Space>
        );
      },
    },
  ];

  const handleUpdateRequest = (record: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(record);
  };

  const handleCancelRequest = (record: any) => {
    setOpenCancelModal(!openCancelModal);
    setOpenCancelData(record);
  };

  const handleCancelRequestClose = (record: any) => {
    setOpenCancelModal(false);
    setOpenCancelData({});
  };

  const handleReturnRequest = (record: any) => {
    setOpenReturnModal(!openReturnModal);
    setOpenReturnData(record);
  };

  const handleUpdateEmail = (record: any) => {
    setOpenUpdateEmailModal(true);
    setUpdateEmailData(record);
  };

  const closeUpdateEmail = () => {
    setOpenUpdateEmailModal(false);
    setUpdateEmailData(null);
  };

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={"fixed"}
        />
      </div>
      <div className="text-center mt-20 mb-30">
        <Pagination
          defaultCurrent={1}
          current={paginationData?.current}
          total={totalData ?? 0}
          onChange={handleChange}
          responsive={true}
          pageSize={paginationData?.page_size ?? 10}
          showSizeChanger={totalData ? true : false}
          // showSizeChanger
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
        />
      </div>
      <UpdateRequest
        handleUpdateRequest={handleUpdateRequest}
        openUpdateModal={openUpdateModal}
        openUpdateData={openUpdateData}
        getList={getList}
      />

      <CancelRequest
        title={openCancelData?.request_id}
        close={handleCancelRequestClose}
        open={openCancelModal}
        deleteValues={openCancelData}
        name={"Request ID"}
        getList={getList}
      />

      <ReturnRequest
        handleReturnRequest={handleReturnRequest}
        openReturnModal={openReturnModal}
        openReturnData={openReturnData}
      />

      <UpdateEmailModal
        visible={openUpdateEmailModal}
        updateEmailData={updateEmailData}
        getList={getList}
        close={closeUpdateEmail}
      />
      {vewReport && (
        <ViewReport visible={vewReport} close={closeViewDrawer} reportData={reportData} />
      )}
    </>
  );
};
export default PublishListTable;
